/*
 * @Author: ningbo.kang
 * @Date: 2019-10-14 17:09:00
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-03-26 16:38:39
 * @Description: 描述
 */
// import loading from "@/assets/images/loading.svg";
import report from '@/assets/images/report.svg';

export default {
  indicator: {
    render() {
      const { type } = this._self.$parent.$attrs;
      let output = (
        <span class="ant-spin-dot-spin">
          <i class="ant-spin-dot-item"></i>
          <i class="ant-spin-dot-item"></i>
          <i class="ant-spin-dot-item"></i>
          <i class="ant-spin-dot-item"></i>
        </span>
      );
      switch (type) {
        case 'report':
          output = <img src={report} style="width:100px; height:100px;"></img>;
          break;
        case 'long':
          output = <span class="long-loading"></span>;
          break;
        default:
      }
      return output;
    },
  },
};
